// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const Marquee = (el) => {
  const ui = {
    el,
    body: select('body', document),
    globalHeader: select('.global-header'),
  };

  const setPageTheme = () => {
    if (window.isTurnStorybook) {
      let thisTheme = ui.el.dataset.theme;
      ui.body.dataset.pageTheme = thisTheme;
    }
  };

  const addEvents = () => {
    setPageTheme();
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default Marquee;
